// jquery
  $(function(){
    // ==========================
    // tab
    // ==========================
    $('.js-tab_btn').each(function(num){
        if(num == 0){
            $(this).addClass('__current')
        }
    })
    $('.js-tab_panel').each(function(num){
        if(num != 0){
            $(this).hide();
        } else {
            $(this).addClass('active');
        }
    })
    
    function setTab(){
        //  url check
        var hash = location.hash;
        var arg  = new Object;
        url = location.search.substring(1).split('&');
        for(i=0; url[i]; i++) {
            var k = url[i].split('=');
            arg[k[0]] = k[1];
        }
        var tab = arg.tab;
      var id = arg.id;  // 'id'クエリパラメータからIDを取得

    if (hash && $(hash).length && $('.js-tab_btn').length > 0) {
        $('.js-tab_btn').removeClass('__current');
        $('.js-tab_btn a[href="' + hash + '"]').parent().addClass('__current');
        $('.js-tab_panel').hide();
        $(hash).fadeIn();
        $(hash).addClass('active');
    }

        // 遅延してアコーディオンのタイトルをクリック
        if (id && $('#' + id).length) {
            setTimeout(function() {
                var targetElement = $('#' + id).next('.faq_dl_bg').find('.js-accordion-title');
                targetElement.click(); // アコーディオンのタイトルをクリックして開く
            }, 300); // 0.3秒後に実行
        }
      
      
        // url = (url.match(/\?tab=\d+$/) || [])[0];
        if(hash != '' && hash != null && $('.js-tab_btn').length > 0 && tab){
            $.when(
                tabindex = Number(tab) - 1,
                $('.js-tab_btn').each(function(num){
                    if(num == tabindex){
                        $(this).addClass('__current')
                    }else{
                        $(this).removeClass('__current')
                    }
                }),
                $('.js-tab_panel').each(function(num){
                    if(num != tabindex){
                        $(this).hide();
                    }else{
                        $(this).fadeIn();
                    }
                })
            ).done(function(){
                var position = $(hash).offset().top;
                $("body,html").stop().animate({
                    //scrollTop: position
                }, 300);
            });
        }
        return false;
    }
    setTab();
    window.addEventListener('hashchange', setTab, false);
    //  click
      $('.js-tab_btn a').click(function () {
        e.preventDefault(); // Prevent default anchor behavior
          $('.js-tab_panel').hide();
          $('.js-tab_panel').removeClass('active');
        $('.js-tab_btn').removeClass('__current');
        $(this).parent().addClass('__current');
        $(this.hash).fadeIn();
        $(this.hash).addClass('active')
        if ($('#howtouse-tab1').hasClass('active')) {
            $('.olive-oil.s-featured-product_wp').show();
            $('.ex-virgin-olive-oil.s-featured-product_wp').hide();
        }
        if ($('#howtouse-tab2').hasClass('active')) {
            $('.ex-virgin-olive-oil.s-featured-product_wp').show();
            $('.olive-oil.s-featured-product_wp').hide();
            
        }
        if(window.featuredProductSlides){
            window.featuredProductSlides.forEach(function (slide) {
                slide.update();
            });
        }
        // URLを取得
        var url = new URL(window.location.href);
        // history.replaceState('', '', url.pathname);
        history.replaceState(null, '', ' ' + this.href); // Update URL with hash
        return false;
    })

  });





  function applyCoupons(cartProducts, hasRedirectToCheckout=false) {
    console.log('applyCounpons', cartProducts, keneiCustomerOrderCount, cartProducts.indexOf('trial-set'));
    let isRedirected = false;
    let codes = [];

    // subscription-setはサブスクリプション購入履歴がなければ反映可能

    if (cartProducts.indexOf('subscription-set') >= 0 && keneiCustomerSubscriptionCount == 0) {
        codes.push('定期購入セット初回割引')
    } else {
        window.discountOnCartProApp.removeCode('定期購入セット初回割引');
    }

    // 初回購入の場合は初回送料無料がつく
    // if (keneiCustomerOrderCount == 0) {
    //     codes.push('初回送料無料')
    // } else {
    //     window.discountOnCartProApp.removeCode('初回送料無料');
    // }
    window.discountOnCartProApp.removeCode('初回送料無料');
    

    // 割引率の高い方から割引を反映する trial-set => ex-virgin-olive-oil >= olive-oil

    if (cartProducts.indexOf('trial-set') >= 0 && keneiCustomerOrderCount == 0) {
        codes.push('トライアルセット初回割引')
    } else {
        window.discountOnCartProApp.removeCode('トライアルセット初回割引');
    }
    if (cartProducts.indexOf('trial-set') == -1 && cartProducts.indexOf('ex-virgin-olive-oil') >= 0 && keneiCustomerOrderCount == 0) {
        codes.push('EXVオリーブオイル初回割引')
    } else {
        window.discountOnCartProApp.removeCode('EXVオリーブオイル初回割引');
    }
    if (cartProducts.indexOf('trial-set') == -1 && cartProducts.indexOf('ex-virgin-olive-oil') == -1 && cartProducts.indexOf('olive-oil') >= 0 && keneiCustomerOrderCount == 0) {
        codes.push('オリーブオイル初回割引')
    } else {
        window.discountOnCartProApp.removeCode('オリーブオイル初回割引');
    }

    console.log('coupons', codes);

    for(var i=0; i<codes.length; i++) {
        if (hasRedirectToCheckout && i == codes.length - 1) {
            window.discountOnCartProApp.applyCodeAndCheckout(codes[i]);
            isRedirected = true;
        } else {
            window.discountOnCartProApp.applyCode(codes[i]);
        }
    }

    if (!isRedirected && hasRedirectToCheckout) {
        // 長めにまってチェックアウトする
        window.setTimeout(function() {
            location.href = '/checkout';
        }, 3000);
    }

    return isRedirected;
  }

  if (location.pathname.match(/^\/cart/)) {
    const checkCode = function() {
        if (!window.discountOnCartProApp) {
            window.setTimeout(checkCode, 300);
            return;
        }
        const cartProducts = [];
        $('.cart-item__details a').each(function() {
            const product = this.href.match(/\/products\/([-_0-9a-z]*)/);
            if (!product) return;
    
            cartProducts.push(product[1]);
        });
    
        applyCoupons(cartProducts);
    };
    checkCode();
  } else if(location.pathname.match(/^\/pages\/checkout_redirect/)) {
    const checkCode2 = function() {
        if (!window.discountOnCartProApp) {
            window.setTimeout(checkCode2, 300);
            return;
        }

        fetch('/cart.json').then((res) => {return res.json()}).then((json) => {
            const cartProducts = [];
            json.items.forEach(item => {
                cartProducts.push(item.handle);
            });
            applyCoupons(cartProducts, true);
        });
    };
    checkCode2();
  } else if(location.pathname.match(/^\/pages\/buy/)) {



    const checkProduct = function() {
        console.log('checkProduct', window.discountOnCartProApp);
        if (!window.discountOnCartProApp) {
            window.setTimeout(checkProduct, 300);
            return;
        }
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const targetProduct = urlParams.get('product');
        const targetCoupon = urlParams.get('coupon');
        const targetSellingPlan = urlParams.get('selling_plan');

        fetch('/cart/clear.js').then((res) => {
            const body = {items: [{id: targetProduct, quantity: 1}]}
            if (targetSellingPlan) {
                body['items'][0].selling_plan = targetSellingPlan;
            }
            fetch('/cart/add.js', {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
            }).then(res2 => {
                const coupons = ['定期購入セット初回割引','EXVオリーブオイル初回割引','オリーブオイル初回割引','トライアルセット初回割引','初回送料無料'];
                coupons.forEach((coupon) => {
                    if (targetCoupon == coupon) {

                    } else {
                        window.discountOnCartProApp.removeCode(coupon);
                    }
                });

                if (targetCoupon && !keneiCustomerOrderCount) {
                    // if (!targetSellingPlan) {
                    //     window.discountOnCartProApp.applyCode('初回送料無料');
                    // }
                    window.discountOnCartProApp.applyCode(targetCoupon);
                    window.setTimeout(function() {
                        location.href='/account/register?checkout_url=%2Fpages%2Fcheckout_redirect';
                    }, 1000);
                } else {
                    location.href='/account/register?checkout_url=%2Fpages%2Fcheckout_redirect';
                }
            }).catch(e => {
                location.href = '/';
            });
        });
    };
    checkProduct();
  } else {
    // const checkCodeMember = function() {
    //     if (!window.discountOnCartProApp) {
    //         window.setTimeout(checkCodeMember, 300);
    //         return;
    //     }
    
    //     // 割引率の高い方から割引を反映する
    //     // TODO: 顧客をチェック
    //     if (meta && meta.page && meta.page.customerId) {
    //         window.discountOnCartProApp.removeCode('定期購入セット初回割引');
    //         window.discountOnCartProApp.removeCode('EXVオリーブオイル初回割引');
    //         window.discountOnCartProApp.removeCode('オリーブオイル初回割引');
    //         window.discountOnCartProApp.removeCode('トライアルセット初回割引');
    //         window.discountOnCartProApp.removeCode('初回送料無料');
    //     }
    // };
    // checkCodeMember();
  }

  if (location.pathname === '/pages/checkout_redirect') {
    window.localStorage.removeItem('redirectCheckout', false);
  }